import { Amplify } from 'aws-amplify';
import { logger } from '../utils/logger';

// AWS Amplify configuration
const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || 'us-east-1_example',
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID || 'example-client-id',
      region: import.meta.env.VITE_COGNITO_REGION || 'us-east-1',
      signUpVerificationMethod: 'code', // 'code' | 'link'
      loginWith: {
        email: true,
        username: false,
        phone: false,
      },
    }
  }
};

// Initialize Amplify
export function configureAmplify() {
  try {
    Amplify.configure(amplifyConfig);
    logger.info('AWS Amplify configured successfully', {
      region: amplifyConfig.Auth.Cognito.region,
      userPoolId: amplifyConfig.Auth.Cognito.userPoolId
    });
  } catch (error) {
    logger.error('Error configuring AWS Amplify', { error });
  }
}

export default amplifyConfig;
